import { render, staticRenderFns } from "./DeansAward.vue?vue&type=template&id=54e92edb&scoped=true"
import script from "./DeansAward.vue?vue&type=script&lang=js"
export * from "./DeansAward.vue?vue&type=script&lang=js"
import style0 from "./DeansAward.vue?vue&type=style&index=0&id=54e92edb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e92edb",
  null
  
)

export default component.exports